import { BarItem } from '@nivo/bar';

export const CustomBarItem = (props) => {
    const { bar, style } = props;
    const minHeight = 16;
    const height = Math.max(bar.height, minHeight);
    const y = bar.y + (bar.height - height) / 2;

    return (
        <BarItem
            {...props}
            bar={{ ...bar, y, height }}
            style={{ ...style, height }}
        />
    );
};
